import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
       
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/food-technology/data";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function MilitaryCommand() {
  const products = [
    
    "Nutritional Analysis Software",
    

  ];
  const data = {
    image: "/industries/food-technology/nutritional-analysis-software.jpg", // Replace with the appropriate image URL
    intro: `Enhance your understanding of food products with our Nutritional Analysis Software. Designed for the food industry, our software provides detailed nutritional information, helping you develop healthier products, meet regulatory requirements, and support informed consumer choices.`,
    keyFeatures: [
      {
        title: "Comprehensive nutritional profiling",
        content: "Analyze detailed nutritional content of food products, including macronutrients, micronutrients, and vitamins.",
      },
      {
        title: "Customizable nutrient databases",
        content: "Utilize and customize nutrient databases to fit your specific product formulations and analysis needs.",
      },
      {
        title: "Regulatory compliance reporting",
        content: "Generate reports that comply with local and international nutritional labeling regulations and standards.",
      },
      {
        title: "Integration with recipe and formulation software",
        content: "Seamlessly integrate with recipe and formulation tools to streamline nutritional analysis within the product development process.",
      },
      {
        title: "Advanced data visualization and reporting",
        content: "Visualize nutritional data with interactive charts and graphs for better insights and decision-making.",
      },
    ],
    howItWorks: `Our Nutritional Analysis Software offers a powerful platform for detailed analysis of food product nutrition. By providing comprehensive profiling, customizable databases, regulatory reporting, and integration with formulation tools, our software supports the development of healthier products and ensures compliance with nutritional standards.`,
    
    benefits: {
      title: "The advantages of our Nutritional Analysis Software",
      data: [
        "Detailed nutritional profiling for accurate product analysis.",
        "Customizable databases to meet specific formulation needs.",
        "Regulatory compliance reporting for accurate labeling.",
        "Seamless integration with recipe and formulation tools.",
        "Advanced data visualization for better insights and decision-making.",
      ],
    },
    industries:
      "Ideal for food manufacturers, product developers, and nutritional analysts aiming to optimize product formulations, ensure compliance, and provide accurate nutritional information to consumers.",
    
    technology: `Our software leverages advanced analytics and customizable databases to provide in-depth nutritional analysis. With robust reporting and integration capabilities, it supports the development of healthier food products and adherence to nutritional regulations.`,
    support: `We offer extensive support and training to ensure effective use of our Nutritional Analysis Software, helping you enhance product development and meet nutritional standards.`,
    industry: `Our solutions are tailored to the food industry, providing tools that support nutritional analysis, regulatory compliance, and product development, while aligning with industry best practices and standards.`,
  
  };
  const content = "Unlock detailed insights into your food products with our Nutritional Analysis Software! From comprehensive nutritional profiling and regulatory reporting to advanced data visualization and integration with formulation tools, we offer the solutions you need to develop healthier products and ensure compliance with nutritional standards."
  
  
  return (
    <>
   <Head>
    <title>Nutritional Analysis Software | Optimize Food Nutrition | Techbrain Networks</title>
    <meta name="description" content="Optimize food nutrition with Techbrain Networks Nutritional Analysis Software, designed for accurate analysis and compliance with nutritional standards." />
    <meta name="keywords" content="nutritional analysis software, food nutrition, Techbrain Networks" />
    <meta property="og:title" content="Nutritional Analysis Software | Optimize Food Nutrition | Techbrain Networks" />
    <meta property="og:description" content="Techbrain Networks Nutritional Analysis Software helps optimize food nutrition with accurate analysis and compliance with nutritional standards." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/food-technology/products/nutritional-analysis-software" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Nutritional Analysis Software" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Nutritional Analysis Software | Optimize Food Nutrition" />
    <meta name="twitter:description" content="Optimize food nutrition with Techbrain Networks Nutritional Analysis Software, designed for accurate analysis and adherence to nutritional standards." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/food-technology/products/nutritional-analysis-software" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Nutritional Analysis Software",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Optimize food nutrition with Techbrain Networks Nutritional Analysis Software, designed for accurate analysis and compliance with nutritional standards.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/food-technology/products/nutritional-analysis-software",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
           <link rel="icon" href="/favicon.png" />

</Head>
<StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#5617ff"} />

      <AppbarIndustry title={"Food Technology"} homeLink={'/industries/food-technology'} link={'/industries/food-technology/products'} />
    <HeroSection img={'/industries/food-technology/nutritional-analysis-software.jpg'}>
    Nutritional Analysis Software
    </HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#020108",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
        {/* Key Features Unleashed */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#5617ff"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#5617ff",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#5617ff"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundposition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
  {/* Industries */}
  <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

          

        {/* Future Developments and Innovations*/}
 
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            Stay informed about upcoming features and innovations in military command and control technology.

          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#5617ff       ",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
          <Box
            sx={{
              width: ['100%'],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#5617ff"} products={products} content={content}/>
          </Box>
        </Box>
      </Box>
      
      <FooterIndustry ourProducts={ourProducts} color={"#5617ff"} bg={"#020108"} />
    </>
  );
}

export default MilitaryCommand;
